import { getReq, postReq } from './axios';
import { fundsBalanceParams, allDepositsParams } from './models';
var BASE_URL = "".concat(apiUrl, "/franchisee-funds");
export var getAllFranchiseeFunds = function getAllFranchiseeFunds(params) {
  return getReq(BASE_URL, {
    params: allDepositsParams(params)
  });
};
export var exportAllFranchiseeFunds = function exportAllFranchiseeFunds(params) {
  return getReq(BASE_URL, {
    params: allDepositsParams(params),
    responseType: 'blob'
  });
};
export var getFranchiseeFunds = function getFranchiseeFunds(params) {
  return getReq("".concat(BASE_URL, "/get-balance"), {
    params: fundsBalanceParams(params)
  });
};
export var getFranchiseeFundsDepositBalance = function getFranchiseeFundsDepositBalance(params) {
  return getReq("".concat(BASE_URL, "/get-deposits-balance"), {
    params: fundsBalanceParams(params)
  });
};
export var postFranchiseeFunds = function postFranchiseeFunds(value) {
  return postReq(BASE_URL, value);
};
export var postFranchiseeFundsDeposit = function postFranchiseeFundsDeposit(value) {
  return postReq("".concat(BASE_URL, "/add-deposit"), value);
};